import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

function updateSearchTypesOrder(data) {
  return fetchWrapper.put(`${config.apis.api.url}/searchtypes/order`, {
    injectToken: true,
    body: data
  });
}

const SearchTypeService = {
  updateSearchTypesOrder
};

export default SearchTypeService;